// import { Injectable } from '@angular/core';
// import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
// import { StoreUsersService } from '@services/cleanfill-core/store-users/store-users.service';
// import { NgxPermissionsGuard, NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
// import { filter, take } from 'rxjs/operators';

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthGuard implements CanActivate {
//   constructor(
//     private permissionsService: NgxPermissionsService,
//     private permissionsGuard: NgxPermissionsGuard,
//     private rolesService: NgxRolesService,
//     private userStore: StoreUsersService
//   ) {}
//   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//     const permissions = this.permissionsService.getPermissions();
//     const roles = this.rolesService.getRoles();
//     if (Object.entries(permissions)?.length === 0 && Object.entries(roles)?.length === 0) {
//       this.userStore.loadActiveUser();
//       await this.setRolesAndPermissions();
//     }

//     return this.permissionsGuard.canActivate(route, state);
//   }

//   async setRolesAndPermissions(): Promise<void> {
//     const [permissions, role] = await Promise.all([
//       this.userStore.activeUserPermissions$
//         .pipe(
//           filter(p => p?.length > 0),
//           take(1)
//         )
//         .toPromise(),
//       this.userStore.activeUserRoles$.pipe(filter(Boolean), take(1)).toPromise()
//     ]);

//     this.permissionsService.loadPermissions(permissions as string[]);
//     this.rolesService.addRole(role as string, permissions as string[]);
//   }
// }
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { CleanFillUserStatus, LegalEntityStatus, UsersClient } from '@services/cleanfill-api/cleanfill-api.generated';
import { AuthService } from '@services/core/auth.service';
import { ConfirmDialogResult, ConfirmDialogType } from '@widgets/site-common/confirm-dialog/confirm-dialog.model';
import { ConfirmDialogService } from '@widgets/site-common/confirm-dialog/confirm-dialog.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private msalService: MsalService,
    public auth: AuthService,
    private dialogService: ConfirmDialogService,
    public router: Router,
    private userClient: UsersClient
  ) { }
  canActivate(): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    const account = this.msalService.getAccount();
    if (!account) {
      return false;
    }
    if (this.auth.isPermissionsLoaded) {
      return true;
    }

    return this.auth.loadPermissions().then((t) => {
      if (t && t.status === CleanFillUserStatus.Deactivated) {
        this.dialogService.confirm(`This account is Deactivated.`, '', ConfirmDialogType.Ok).then((result) => {
          if (result === ConfirmDialogResult.Ok) {
            this.msalService.logout();
            return;
          }
        });
        return;
      }
      if (t && !t?.isTermAccepted && !t?.legalEntityUniqueId) {
        return this.router.parseUrl('/register/terms');
      }
      if (t && !t?.isApproved) {
        this.dialogService.confirm(`This account is not approved yet.`, '', ConfirmDialogType.Ok).then((result) => {
          if (result === ConfirmDialogResult.Ok) {
            this.msalService.logout();
            return;
          }
        });
        return;
      }
      if (!t) {
        return this.userClient
          .createUser(undefined)
          .toPromise()
          .then((x) => {
            this.auth.loadActiveUser(x);
            return this.router.parseUrl('/register/choose/company/new');
          });
      }

      if (!t.legalEntityUniqueId || t.legalEntityStatus === LegalEntityStatus.Draft) {
        return this.router.parseUrl('/register/choose/company/new');
      }
      if (t?.policies?.length === 0) {
        return this.router.parseUrl('/access-denied');
      }
      return this.auth.loadActiveUser(t);
    });
  }
}
